import { takeEvery, put, select } from "redux-saga/effects"
import {
  startSubmit,
  setSubmitFailed,
  setSubmitSucceeded,
  stopSubmit,
  getFormValues,
  initialize,
} from "redux-form"
import { showToast } from "@infotech/uikit-toasts"
import { setRolePermissions } from "src/engine/repositories/permissions"
import { SUBMIT_FORM } from "../actions/types"
import { FORM_NAME, formStateToPermissionKeys } from "../helpers"
import { selectRole } from "../selectors"

function* submitForm() {
  yield put(startSubmit(FORM_NAME))

  try {
    const formState = yield select(getFormValues(FORM_NAME))
    const role = yield select(selectRole)

    yield setRolePermissions({
      role,
      permissions: formStateToPermissionKeys(formState),
    })

    yield put(setSubmitSucceeded(FORM_NAME))
    yield put(stopSubmit(FORM_NAME))
    yield put(initialize(FORM_NAME, formState))
  } catch (error) {
    showToast({
      type: `error`,
      message: `Ошибка при сохранении: ${error.message}`,
      hideIn: 5,
    })
    yield put(setSubmitFailed(FORM_NAME))
  }
}

export default function* submitFormWatcher() {
  yield takeEvery(SUBMIT_FORM, submitForm)
}
